import {SearchFilter} from './search-filter';
import {SearchOrder} from './search-order';

export class SearchParams {
  public pageIndex: number;
  public pageSize: number;
  public filter: SearchFilter [];
  public order: SearchOrder;
}
